import { routes } from "../../constants/routes";
export const breadcrumbLink = [
  {
    label: "Lead Capture",
    link: routes.LEADCAPTUREFORM,
    handleClick: () => { },
  },
  {
    label: "Form List",
    link: routes.LEADCAPTUREFORM,
  }
];
export const breadcrumbLinkLeadList = () => [
  {
    label: "Lead Capture",
    link: routes.LEADCAPTUREFORM,
  },
  {
    label: "Form List",
    link: routes.LEADCAPTUREFORM,
    handleClick: () => { },
  },
  {
    label: "Leads",
    link: ""
  }
];
